import getLanguageLocale from '../multi-language/getLanguageLocale.js'
export default (fromDate, toDate) => `${fromDate.locale(getLanguageLocale()).format('MMMM DD YYYY, HH:mm')} - ${toDate.locale(getLanguageLocale()).format('MMMM DD YYYY, HH:mm')}`
